<template>
  <div class="tile shadow" @click="tileClicked">
    <div class="top p-3">
      <slot name="image"></slot>
    </div>
    <div class="bottom m-3">
      <div class="line">
        <strong>
          <slot name="line1"></slot>
        </strong>
      </div>
      <div class="line">
        <slot name="line2"></slot>
      </div>
      <div class="line">
        <slot name="line3"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageTile',
  methods: {
    tileClicked() {
      this.$emit('tile-clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.tile {
  border-radius: 10%;
  cursor: pointer;
  background-color: white;
  display: grid;
  align-content: stretch;
  grid-template-columns: 100%;
  grid-template-rows: 75% 25%;
}

.top {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  place-self: center;
  align-self: center;
}

.bottom {
  grid-column: 1 / 1;
  grid-row: 2 / 3;
  align-self: end;
  .line {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
